import { getProjectBalances, getCustomerBalances } from '@/api/bank-account'

// Same idea as online-banking-ui store/balance.js: a short TTL so moving between
// tabs / pages does not ask the vendors for every ledger again, and one shared
// promise so two components asking at once only cost one request.
const TTL = 30 * 1000

// Not in state: promises must not be reactive.
const inflight = {}

const keyOf = (apiMode, uid) => `${apiMode}:${uid}`

const state = {
  lists: {}
}

const mutations = {
  SET_LIST: (state, { key, data }) => {
    state.lists = {
      ...state.lists,
      [key]: { data, fetchedAt: Date.now() }
    }
  }
}

const actions = {
  fetch({ state, commit }, { apiMode, uid, force = false }) {
    if (!uid) return Promise.resolve([])

    const key = keyOf(apiMode, uid)
    const cached = state.lists[key]
    if (!force && cached && Date.now() - cached.fetchedAt < TTL) {
      return Promise.resolve(cached.data)
    }

    if (inflight[key]) return inflight[key]

    const request = apiMode === 'customer' ? getCustomerBalances(uid) : getProjectBalances(uid)
    inflight[key] = request
      .then(({ result, data }) => {
        if (!result || !data) return null
        // A list with a failed vendor call is shown, but not cached, so the next visit retries.
        if (!data.some(item => item.unavailable)) {
          commit('SET_LIST', { key, data })
        }
        return data
      })
      .catch(() => null)
      .finally(() => {
        delete inflight[key]
      })

    return inflight[key]
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
